import { DatePipe, formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FuseConfigService } from '@fuse/services/config';
import { TranslocoService } from '@ngneat/transloco';
import { Scheme } from 'app/core/config/app.config';
import { User } from 'app/models/user.model';
import { environment } from 'environments/environment';
import { finalize, Observable, of } from 'rxjs';
import { LanguagesService } from '../languages/languages.service';

@Injectable({
    providedIn: 'root',
})
export class SettingsService {
    /**
     * Objects
     */
    form: FormGroup = new FormGroup({
        image: new FormControl({ value: '', disabled: false }),
        user_name: new FormControl({ value: '', disabled: true }),
        language: new FormControl({ value: '', disabled: false }),
        first_name: new FormControl({ value: '', disabled: true }),
        last_name: new FormControl({ value: '', disabled: true }),
        registered_at: new FormControl({ value: '', disabled: true }),
        last_login_at: new FormControl({ value: '', disabled: true }),
        email: new FormControl({ value: '', disabled: true }),
        phone: new FormControl({ value: '', disabled: true }),
        sites: new FormControl({ value: '', disabled: true }),
        scheme: new FormControl({ value: '', disabled: false }),
    });

    /**
     * Constructor
     * @param _http
     * @param _datePipe
     */
    constructor(
        private _http: HttpClient,
        private _datePipe: DatePipe,
        private _fuseConfigService: FuseConfigService,
        private _languagesService: LanguagesService,
        private _translocoService: TranslocoService
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // Public methods
    // -----------------------------------------------------------------------------------------------------

    resetForm(): void {
        this.form.reset();
        console.log(this.form);
    }

    populateForm(user: User) {
        this.form.setValue({
            image: '',
            user_name: user.user_name,
            language: user.language,
            first_name: user.first_name,
            last_name: user.last_name,
            registered_at: this.formatDate(new Date(user.registered_at)),
            last_login_at: this.formatDate(new Date(user.last_login_at)),
            email: user.email,
            phone: user.phone,
            sites: user.sites_delimited,
            scheme: user.scheme,
        });
        console.log(user.registered_at, new Date(user.registered_at));
    }

    onSubmit(
        originalUser: User,
        scheme: Scheme,
        lang: string,
        image: any
    ): Observable<any> {
        let updatedUser: User = JSON.parse(JSON.stringify(originalUser));
        updatedUser.language = lang;
        updatedUser.scheme = scheme;
        if (image) {
            updatedUser.photo = image;
        }

        console.log(updatedUser);

        if (updatedUser != originalUser) {
            return this.updateUserInformation(updatedUser);
        }

        return of(null);
    }

    /**
     * Set the layout on the config
     *
     * @param layout
     */
    // setLayout(layout: string): void {
    //     // Clear the 'layout' query param to allow layout changes
    //     this._router.navigate([], {
    //         queryParams        : {
    //             layout: null
    //         },
    //         queryParamsHandling: 'merge'
    //     }).then(() => {

    //         // Set the config
    //         this._fuseConfigService.config = {layout};
    //     });
    // }

    /**
     * Set the scheme on the config
     *
     * @param scheme
     */
    setScheme(scheme: Scheme): void {
        this._fuseConfigService.config = { scheme };
    }

    /**
     * Set the theme on the config
     *
     * @param theme
     */
    // setTheme(theme: Theme): void {
    //     this._fuseConfigService.config = {theme};
    // }

    /**
     * Set the active lang
     * @param lang
     */
    setActiveLang(lang: string): void {
        // Set the active lang
        this._translocoService.setActiveLang(lang);
        this._languagesService.lang = lang;
    }

    // -----------------------------------------------------------------------------------------------------
    // Private methods
    // -----------------------------------------------------------------------------------------------------

    // PUT methods
    private updateUserInformation(user: User): Observable<any> {
        return this._http.put<User>(
            `${environment.backendURL}${environment.updateUserInformationURL}`,
            user
        );
    }

    private formatDate(value: Date): string {
        // Manually extract date components
        const year = value.getFullYear(); // Get full year
        const month = (value.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
        const day = value.getDate().toString().padStart(2, '0'); // Get day
        const hours = value.getHours().toString().padStart(2, '0'); // Get hours
        const minutes = value.getMinutes().toString().padStart(2, '0'); // Get minutes

        // Construct the formatted date string in 'dd/MM/yyyy HH:mm' format
        const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;
        return formattedDate;
    }
}
